import { Component, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Auth } from './services/auth';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from 'sham-components/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.html',
})
export class App implements OnInit {
  private langService = inject(LanguageService);

  readonly authService = inject(Auth);
  /**
   *
   */
  constructor() { }

  ngOnInit(): void {
    this.langService.init();
  }
  onclick = output({});
}
